/* eslint-disable no-undef */
export const API_URL = process.env.REACT_APP_API;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_API;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export * from "./theme";
